/**
 * Canonical permission catalogue. Keep additions sorted by feature.
 * Backend MUST enforce these — UI gating is defence-in-depth only.
 */
export const PERMISSIONS = [
  // Workspace
  'dashboard.view',
  'gettingstarted.view',
  'settings.view',
  'settings.manage',

  // Developer
  'apis.view',
  'sdks.view',
  'mcp.view',
  'webhooks.view',
  'webhooks.manage',
  'sandbox.use',
  'dbschema.view',
  'aidocschat.view',
  'aiintegration.view',

  // Operations
  'payments.view',
  'payments.refund',
  'settlement.view',
  'terminals.view',
  'terminals.provision',
  'reporting.view',
  'collections.view',
  'paylinks.view',
  'vpayments.view',
  'cloudconnect.view',
  'softposconnect.view',
  'finance.view',

  // Partner
  'customers.view',
  'companies.view',
  'estate.view',
  'products.view',
  'residuals.view',
  'subscriptions.manage',
  'productionreadiness.view',

  // Infrastructure
  'treasury.view',
  'tronc.view',
  'capital.view',
  'identity.view',
  'risk.view',
  'compliance.view',

  // AI Operations
  'aioverview.view',
  'aiincident.view',
  'aiops.view',
  'aiagents.view',

  // Support
  'documentation.view',
  'status.view',
  'support.view',

  // Connect. `connect.view` covers the surfaces every Connect role may use
  // (Users, API Keys, Products — the API scopes their data server-side).
  // Companies and Estate get their own permissions because the Connect API
  // gates them harder: companies = admin only, estate = admin + isvAdmin.
  'connect.view',
  'connect.companies.view',
  'connect.estate.view',
] as const;

export type Permission = (typeof PERMISSIONS)[number];

export const isPermission = (value: string): value is Permission =>
  (PERMISSIONS as readonly string[]).includes(value);
